import { Box, Typography } from '@mui/material';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

interface ReviewCatalogSelectionFooterProps {
    children: ReactNode;
    selectedCount?: number;
    leadingAction?: ReactNode;
    hideSelectedCount?: boolean;
    minHeight?: string;
}

export const ReviewCatalogSelectionFooter = ({
    children,
    selectedCount,
    leadingAction,
    hideSelectedCount = false,
    minHeight,
}: ReviewCatalogSelectionFooterProps) => {
    const { t } = useTranslation();

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'row',
                width: '100%',
                borderRadius: '0 0 12px 12px',
                border: '1px solid',
                borderColor: 'divider',
                padding: '16px',
                backgroundColor: 'background.paper',
                ...(minHeight ? { minHeight } : {}),
            }}
            data-testid="review-catalog-selection-footer"
            data-testclass="review-catalog-selection-footer"
        >
            {leadingAction}
            {!hideSelectedCount && (selectedCount ?? 0) > 0 ? (
                <Typography
                    variant="body2"
                    sx={{
                        color: 'common.black',
                        marginLeft: leadingAction ? '16px' : 0,
                    }}
                >
                    {t('{{count}} item selected', { count: selectedCount })}
                </Typography>
            ) : null}
            <Box sx={{ marginLeft: 'auto' }}>{children}</Box>
        </Box>
    );
};
